// import {Form} from '../stores/Form';
import {BreadCrumbsList} from '../types';
import {Form} from '../../../stores/Form';

export type BreadcrumbData = {
    title: string;
    ename: string;
    level: number;
    session: string;
};

export const mapFormToBreadcrumbs = (parent: Form | null, activeLevel: number): BreadCrumbsList => {
    const mapData = (form: Form | null, data: Array<BreadcrumbData>) => {
        if (form && form.level <= activeLevel) {
            const info = {
                title: form.title,
                ename: form.ename,
                level: form.level,
                session: form.session
            };
            return mapData(form.activeSubForm, data.concat(info));
        }
        return data;
    };

    return mapData(parent, []);
};
